import './Scrollme.scss'


export default () => {
    const handleScrollClick = (e: any) => window.scrollTo(0, 80);
    return (
        <div className='scrollme'>
            <div className='scrollme-inner'>
                <div onClick={handleScrollClick} className='scroller'></div>
            </div>
        </div>
    )
};